import { useEffect, useState, useCallback } from "react";
import { DocumentContext } from "./context";
import { getDocumentVerificationCounts } from "services/leadsService";
import { useAuthContext } from "app/contexts/auth/context";

export const DocumentProvider = ({ children }) => {
    const { isAuthenticated } = useAuthContext();
    const [counts, setCounts] = useState({
        TotalDocuments: 0,
        VerifiedDocuments: 0,
        RejectedDocuments: 0,
        PendingDocuments: 0,
        PendingLeads: 0,
        VerifiedLeads: 0,
    });

    const [loading, setLoading] = useState(true);

    const fetchCounts = useCallback(async () => {
        if (!isAuthenticated) return;

        setLoading(true);

        const res = await getDocumentVerificationCounts();
        if (res.success && res.data) {
            setCounts(prev => ({ ...prev, ...res.data }));
        }

        setLoading(false);
    }, [isAuthenticated]);

    // Initial load
    useEffect(() => {
        if (isAuthenticated) {
            fetchCounts();
        }
    }, [fetchCounts, isAuthenticated]);

    return (
        <DocumentContext.Provider value={{ counts, loading, refreshCounts: fetchCounts }}>
            {children}
        </DocumentContext.Provider>
    );
};